/** The one public origin used in links, metadata, probes, and redirects. */
export const CANONICAL_PORTAL_ORIGIN = 'https://djgg.jachai.dev';

/** Firebase-owned aliases kept only so old links can reach the canonical host. */
export const LEGACY_PORTAL_HOSTS = new Set([
  'djgg-platform.web.app',
  'djgg-platform.firebaseapp.com',
]);

function normalizedHost(host: string): string {
  return host.split(',')[0]!.trim().toLowerCase().replace(/:\d+$/, '');
}

export function isLegacyPortalHost(host: string): boolean {
  return LEGACY_PORTAL_HOSTS.has(normalizedHost(host));
}

/**
 * Return the canonical destination for a request on a Firebase alias.
 * Firebase's reserved auth endpoints stay on their configured origin: moving
 * an OAuth callback between origins can lose the browser's pending auth state.
 */
export function legacyPortalRedirectUrl(host: string, path = '/'): string | null {
  if (!isLegacyPortalHost(host)) return null;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (normalizedPath === '/__' || normalizedPath.startsWith('/__/')) return null;
  return `${CANONICAL_PORTAL_ORIGIN}${normalizedPath}`;
}
